import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AlertController, LoadingController, Platform } from "@ionic/angular";
import { Storage } from "@ionic/storage";

import { Router } from "@angular/router";
import * as base64 from "base-64";
import { BnNgIdleService } from "bn-ng-idle";
import * as CryptoJS from "crypto-js";
import { timeout } from "rxjs/operators";
import * as utf8 from "utf8";
import { environment } from "../../environments/environment";
import { STORAGE } from "../constant/storages";
import { AppService } from "../services/app.service";
import { errMsg } from "../text_control/error-msg";
import { BTN } from "../text_control/text_button";
import { _getStorage, _setStorage } from "../utils/local-storage";
const keyCrypto = "6e01230e3c23c0ba9d45000e53f3ede6";

@Injectable({
  providedIn: "root",
})
export class ApiserviceService {
  apiUrl = "";
  getABB = "";
  searchcustomer = "";
  updateCustomer = "";
  searchAddress = "";
  createfulltax = "";
  searchTaxinvoice = "";
  replaceEditCustomer = "";
  confirmReplace = "";
  apiLogin = "";
  getPDF = "";
  getNewPDF = "";
  confirmCreate = "";
  draftTransaction = "";

  searchCreditNote = "";
  createCreditNote = "";

  taxinvoiceDetail = "";
  reportSearch = "";
  inquirySearch = "";
  reportExport = "";
  resendSearch = "";

  // Config Api
  getCustomerLists = "";
  getCustomerDetail = "";
  editCustomer = "";

  getSellerLists = "";
  getSellerDetail = "";
  editSeller = "";

  inquirySearchList = "";
  inquirySearchDetail = "";
  getResendInvoice = "";
  getNewResendInvoice = "";
  getTaxInvoiceDetail = "";

  getConfiguration = "";
  updateConfiguration = "";
  getRoleManagement = "";
  setRoleManagement = "";

  getListLocation = "";
  externalExportExcel = "";
  getCnout = "";
  externalReportCSV = "";
  getSortPriority = "";

  UrlBackoffice = "";
  searchDeleteFulltax = "";
  confirmDeleteFulltax = "";
  searchLog = "";
  searchUnlock = "";
  confirmUnlock = "";
  B2C_authority = "";
  getAD2RoleManage = "";
  B2C_LOGOUT = "";
  get_permissions = "";

  constructor(
    private http: HttpClient,
    public storage: Storage,
    private platform: Platform,
    public loadingController: LoadingController,
    private bnIdle: BnNgIdleService,
    private router: Router,
    public alertController: AlertController,
    public appService: AppService
  ) {
    this.mappingEnvironment();
    this.sessionTimeout();
  }

  async loading() {
    const loading = await this.loadingController.create({
      message: "Please wait...",
    });
    return loading;
  }

  _post(apiUrl: any, data: any, config?: any) {
    return new Promise<any>(async (resolve, reject) => {
      const loading = await this.loadingController.create({
        message: "Please wait...",
      });
      await loading.present();

      let headers = {
        ...this.getHeader(),
        ...(config && config)
      }
      let options = {
        headers: headers
      };

      options.headers["Content-Type"] = "application/text";

      console.log("options=====:: ", options);

      const bodyRes = await this.encryptBody(data);
      this.http
        .post(apiUrl, bodyRes, options)
        .pipe(timeout(60000))
        .subscribe(
          async (res: any) => {
            const bodyRes = await this.decryptBody(res);
            await loading.dismiss();

            resolve(bodyRes);
          },
          async (err) => {
            await loading.dismiss();
            if (err.status !== 0) {
              const bodyRes = await this.decryptBody(err.error);
              if (bodyRes["statusCode"]) {
                const alert = await this.alertController.create({
                  cssClass: "my-custom-class",
                  message: bodyRes.statusMessage,
                  buttons: [
                    {
                      text: "OK",
                      cssClass: "alertButton",
                      handler: (blah) => {
                        if (
                          bodyRes.statusCode === 401 ||
                          bodyRes.statusCode === 440
                        ) {
                          this.appService.logout();
                        }
                      },
                    },
                  ],
                });
                await alert.present();
                reject(err);
              } else {
                this.errorMsg(errMsg.error);
                reject(err);
              }
            } else {
              this.errorMsg(errMsg.error);
              reject(err);
            }
          }
        );
    });
  }

  _get(apiUrl: any) {
    return new Promise(async (resolve, reject) => {
      const loading = await this.loadingController.create({
        message: "Please wait...",
      });
      await loading.present();

      let options = {
        headers: this.getHeader(),
      };
      this.http.get(apiUrl, options).subscribe(
        async (res: any) => {
          const bodyRes = await this.decryptBody(res);
          await loading.dismiss();
          resolve(bodyRes);
        },
        async (err) => {
          await loading.dismiss();
          if (err.status !== 0) {
            const bodyRes = await this.decryptBody(err.error);
            if (bodyRes["statusCode"]) {
              const alert = await this.alertController.create({
                cssClass: "my-custom-class",
                message: bodyRes.statusMessage,
                buttons: [
                  {
                    text: "OK",
                    cssClass: "alertButton",
                    handler: (blah) => {
                      if (
                        bodyRes.statusCode === 401 ||
                        bodyRes.statusCode === 440
                      ) {
                        this.appService.logout();
                      }
                    },
                  },
                ],
              });
              await alert.present();
            } else {
              this.errorMsg(errMsg.error);
              reject(err);
            }
          } else {
            reject(err);
            this.errorMsg(errMsg.error);
          }
        }
      );
    });
  }

  _delete(apiUrl: any, data: any) {
    let options = {
      headers: this.getHeader(),
    };
    console.log("web send Header [", options);

    return new Promise((resolve, reject) => {
      this.http.delete(apiUrl, options).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  sessionTimeout() {
    this.bnIdle.startWatching(3600).subscribe((res) => {
      if (res) {
        const get_keyCardID = _getStorage(STORAGE.DATA_KEY_CARDID);
        localStorage.clear();
        this.storage.clear();
        _setStorage(
          STORAGE.DATA_KEY_CARDID,
          get_keyCardID === null ? [] : get_keyCardID
        );
        setTimeout(() => {
          this.router.navigateByUrl("/login");
        }, 500);
      }
    });
  }

  getHeader() {
    const getPermissionToken = _getStorage(STORAGE.PERMISSION_TOKEN);
    const getAccess_token = _getStorage(STORAGE.B2C_TOKEN);
    let header = {};

    header["api-key"] = environment.apikey;
    // if (environment.production) {
    //   header["api-key"] = `${environment.pentest === true
    //     ? "2b609bdd40914c81a05b757eff0aed9c"
    //     : "61f5e2c153f34f41b9772964dd6b7cb9"
    //     }`;
    // }
    header["Ocp-Apim-Trace"] = true;
    header["Content-Type"] = "application/json";
    header["permissionToken"] = getPermissionToken;
    header["authorization"] = getAccess_token;

    return header;
  }
  async errorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  decryptBody(body: any) {
    var bytes = CryptoJS.AES.decrypt(body.api, keyCrypto);
    var originalText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(originalText);
  }
  encryptBody(body: any) {
    const setType = JSON.stringify(body);
    const ciphertext = CryptoJS.AES.encrypt(setType, keyCrypto).toString();
    return ciphertext;
  }

  async setBase64(text) {
    // const base64 = await Buffer.from(text).toString('base64');
    // return base64;

    var bytes = utf8.encode(text);
    var encoded = base64.encode(bytes);
    return encoded;
  }

  async getBase64(encode) {
    var bytes = base64.decode(encode);
    var text = utf8.decode(bytes);
    return text;
  }

  mappingEnvironment() {
    this.apiUrl = environment.apiUrl;

    this.getABB = environment.getABB;
    this.searchcustomer = environment.searchcustomer;
    this.updateCustomer = environment.updateCustomer;
    this.searchAddress = environment.searchAddress;
    this.createfulltax = environment.createfulltax;
    this.replaceEditCustomer = environment.replaceEditCustomer;
    this.searchTaxinvoice = environment.searchTaxinvoice;
    this.confirmReplace = environment.confirmReplace;
    this.confirmCreate = environment.confirmCreate;
    this.draftTransaction = environment.draftTransaction;
    this.getPDF = environment.getPDF;
    this.getNewPDF = environment.getNewPDF;
    this.apiLogin = environment.ApiLogin;

    this.searchCreditNote = environment.searchCreditNote;
    this.createCreditNote = environment.createCreditNote;

    this.taxinvoiceDetail = environment.taxinvoiceDetail;
    this.reportSearch = environment.reportSearch;
    this.inquirySearch = environment.inquirySearch;
    this.reportExport = environment.reportExport;
    this.resendSearch = environment.resendSearch;

    this.getCustomerLists = environment.getCustomerLists;
    this.getCustomerDetail = environment.getCustomerDetail;
    this.editCustomer = environment.editCustomer;

    this.getSellerLists = environment.getSellerList;
    this.getSellerDetail = environment.getSellerDetail;
    this.editSeller = environment.editSeller;
    this.inquirySearchList = environment.inquirySearchList;
    this.inquirySearchDetail = environment.inquirySearchDetail;
    this.getTaxInvoiceDetail = environment.getTaxInvoiceDetail;
    this.getResendInvoice = environment.getResendInvoice;
    this.getNewResendInvoice = environment.getNewResendInvoice;
    this.getConfiguration = environment.getConfiguration;
    this.updateConfiguration = environment.updateConfiguration;
    this.getRoleManagement = environment.getRoleManagement;
    this.setRoleManagement = environment.setRoleManagement;
    this.getListLocation = environment.getListLocation;
    this.externalExportExcel = environment.externalExportExcel;
    this.getCnout = environment.getCnout;
    this.externalReportCSV = environment.externalReportCSV;
    this.getSortPriority = environment.getSortPriority;

    this.UrlBackoffice = environment.UrlBackoffice;
    this.searchDeleteFulltax = environment.searchDeleteFulltax;
    this.confirmDeleteFulltax = environment.confirmDeleteFulltax;
    this.searchLog = environment.searchLog;
    this.searchUnlock = environment.searchUnlock;
    this.confirmUnlock = environment.confirmUnlock;
    this.B2C_authority = environment.B2C_authority;
    this.getAD2RoleManage = environment.getAD2RoleManage;
    this.B2C_LOGOUT = environment.B2C_LOGOUT;
    this.get_permissions = environment.get_permissions;
  }

  clearTimeout() {
    this.bnIdle.resetTimer();
  }
}
